module.exports = __webpack_public_path__ + "img/egg.18542bd5.svg";